import { useEffect, useState, useTransition } from "react";
import {
  Controller,
  FieldError,
  SubmitHandler,
  useForm,
} from "react-hook-form";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import { coursesCreateInterface } from "../../api/types/types";
import { useCourses } from "../../api/useProducts/useCourses";
import { CustomButton, InputField, Sidebar } from "../../components";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FileUploadIcon from "../../components/FileUploadIcon";
import useSingleFileUpload from "../../hook/useSingleFileUpload";
interface CoursesFormData {
  title: string;
}
const AddCourses = () => {
  const navigate = useNavigate();
  const { mutate, isPending: coursePending } = useCourses();

  const { uploadImage, isUploading } = useSingleFileUpload();
  const [activeTab, setActiveTab] = useState(false);
  const [isPending, startTransition] = useTransition();

  const handleTabChange = (tabName: boolean) => {
    startTransition(() => {
      setActiveTab(tabName);
    });
  };
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    control,
    watch,
    reset,
    formState: { errors },
  } = useForm<coursesCreateInterface>();
  const [uploadedData, setUploadedData] = useState<File>();

  const onSubmit: SubmitHandler<coursesCreateInterface> = async (data) => {
    let hasError = false;
    if (description === "<p><br></p>" && !activeTab) {
      setError("description", {
        type: "manual",
        message: "description is required",
      });
      hasError = true;
    }
    // if (!uploadedData) {
    //   setError("image", {
    //     type: "manual",
    //     message: "Image is required",
    //   });
    //   hasError = true;
    // }
    if (!hasError) {
      let imageUrl;
      if (uploadedData) {
        imageUrl = await uploadImage(uploadedData);
      }
      mutate(
        {
          title: data.title,
          image: imageUrl,
          description: data?.description || "",
          isCustom: activeTab,
          courseLink: data.courseLink || "",
        },
        {
          onSuccess: (data) => {
            toast.success("successfully created");
            if (!activeTab) {
              navigate(`/courses/class/${data?.course?.id}`);
            } else {
              navigate(`/courses`);
            }
          },
          onError: (error: any) => {
            toast.error(error.response.data.message);
          },
        }
      );
    }
  };
  const description = watch("description");

  useEffect(() => {
    if (description === "<p><br></p>" && !activeTab) {
      console.log("1");
      setError("description", {
        type: "manual",
        message: "description is required",
      });
    } else {
      console.log("2");
      clearErrors("description");
    }
  }, [description, activeTab]);
  // useEffect(() => {
  //   if (uploadedData) {
  //     clearErrors("image");
  //   }
  // }, [uploadedData]);
  const breadcrumbItems = [
    { title: "Courses", link: "courses" },
    { title: "Add " },
  ];
  useEffect(() => {
    reset();
    setUploadedData(undefined);
  }, [activeTab]);
  return (
    <Sidebar>
      <div className="mt-3">
        <CustomBreadcrumb items={breadcrumbItems} />
      </div>
      <div className="flex justify-center">
        <div className="flex justify-center rounded-2xl bg-gray-200 p-2 ">
          <button
            className={`px-4 py-2 mr-2 relative min-w-28 transition-all duration-300 font-medium rounded-xl ${
              !activeTab ? "text-darkCyan bg-white " : "text-gray-400 "
            }`}
            onClick={() => handleTabChange(false)}
            disabled={isPending}
          >
            Custom
          </button>
          <button
            className={`px-4 py-2 relative min-w-28 transition-all duration-300 font-medium rounded-xl ${
              activeTab ? "text-darkCyan bg-white" : "text-gray-400 "
            } `}
            onClick={() => handleTabChange(true)}
            disabled={isPending}
          >
            Link
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
        <div>
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-3 mt-4">
            <InputField
              label="Title"
              placeholder="Enter title"
              type="text"
              register={register("title", {
                required: "title are required",
              })}
              error={errors.title?.message}
            />
            {activeTab && (
              <InputField
                label="Link"
                placeholder="Enter Link"
                type="url"
                register={register("courseLink", {
                  required: !activeTab ? false : "link are required",
                  pattern: {
                    value:
                      /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                    message: "Please enter a valid URL",
                  },
                })}
                error={errors.courseLink?.message}
              />
            )}
          </div>
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-3 mt-4">
            <div className=" mt-2">
              <p className="block text-gray-700 mb-2">Description</p>
              <Controller
                name="description"
                control={control}
                rules={{
                  required: !activeTab ? "description is required" : false,
                }}
                render={({ field }) => (
                  <ReactQuill
                    {...field}
                    // onChange={(value) => {
                    //   field.onChange(value);
                    // }}
                    className="quill-editor"
                    modules={{
                      toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        ["blockquote", "code-block"],
                        [{ header: 1 }, { header: 2 }],
                        [{ list: "ordered" }, { list: "bullet" }],

                        [{ size: ["small", false, "large", "huge"] }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],

                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                )}
              />
              {errors.description && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.description.message}
                </p>
              )}
            </div>
            <div className="mt-2">
              <p className="block text-gray-700 mb-2">Upload Image</p>

              <div className="mt-3">
                <label htmlFor="file">
                  <div
                    role="button"
                    className="flex flex-col justify-center items-center min-h-52 border-[1.5px] border-dashed border-gray-400 rounded-2xl"
                  >
                    {uploadedData ? (
                      <p className="text-center text-sm text-gray-600">
                        {uploadedData.name}
                      </p>
                    ) : (
                      <>
                        <FileUploadIcon />
                        <CustomButton
                          btntext="Upload"
                          addclass="mt-3"
                          handleClick={() =>
                            document.getElementById("file")?.click()
                          }
                        />
                      </>
                    )}
                  </div>
                </label>
                <input
                  type="file"
                  className="hidden"
                  id="file"
                  accept={"image/jpeg, image/png, image/jpg"}
                  onChange={(e) => {
                    if (e.target.files?.[0]) {
                      setUploadedData(e.target.files[0]);
                    }
                  }}
                />
              </div>
              {errors.image && (
                <p className="text-red-500 text-sm mt-1">
                  {(errors.image as FieldError)?.message}
                </p>
              )}
            </div>
          </div>
        </div>
        {/* )} */}
        <CustomButton
          type="submit"
          btntext="Submit"
          isLoading={coursePending || isUploading}
          addclass="mt-9 mx-auto w-1/2"
        />
        {/* <FileUploadModal modalOpen={modalOpen} setModalOpen={setModalOpen} /> */}
      </form>
    </Sidebar>
  );
};

export default AddCourses;
